angular.module(NgAppName).component('crGenericContactForm', {
	templateUrl: 'crGenericContactForm.html',
	bindings: {
		user: '<',
		form: '<',
		showName: '<',
		showEmail: '<',
		showPhone: '<',
		showPassword: '<',
		showMessage: '<',
		showLabels: '<',
		customClass: '@',
		errorMessages: '<',
		tabindexOrder: '<' ,
		placeholderName: '@',
		placeholderEmail: '@',
		placeholderPhone: '@',
		placeholderMessage: '@',
		enforceEmptyPlaceholders: "@",
		hideFields: '<',
		isMobile: '<',
		messageLabel: '@',
		messageClass: "@",
		emptyMessage: '<',
		popupName: '@'
	},
	controller: ['patterns', '$element', '$interval', '$timeout', 'PubSub', function(patterns, $element, $interval, $timeout, PubSub) {
		var ctrl = this;
		ctrl.emptyMessageWarning = 'A little info will help us find you an amazing apartment!';
		if (!!ctrl.popupName && ctrl.popupName === 'popup-sell') {
			ctrl.emptyMessageWarning = 'A little info will help us!';
		}
		if (!ctrl.messageLabel) {
			ctrl.messageLabel = 'Please tell us what you are looking for';
		}
		ctrl.messageAlsoAddAnyQuestionsOrMessage = "Also add any questions or message";
		ctrl.phoneHasError = false;

		this.$onInit = () => {
			ctrl.patterns = patterns;

			this.holderName = this.placeholderName ? this.placeholderName : (this.enforceEmptyPlaceholders ? "" : "Name*");
			this.holderEmail = this.placeholderEmail ? this.placeholderEmail : (this.enforceEmptyPlaceholders ? "" : "Email*");
			this.holderPhone = this.placeholderPhone || "Phone Number";
			this.holderMessage = this.placeholderMessage || "Your message*";

			if (!this.tabindexOrder) {
				this.tabindexOrder = {
					name: 1,
					email: 1,
					password: 1,
					phone: 1,
					message: 1
				}
			}
		}

		this.fieldChange = function(key) {
			// if the form is not valid then remove the backend error associated to the field
			if (!this.form[key].$valid) {
				this.form[key].$setValidity(key + 'Exist', true);
				this.form[key].$setValidity(key + 'Short', true);
				this.form[key].$setValidity(key + 'Global', true);
			}
			// reset global errors
			if (this.form.globalErrors && this.form.globalErrors.length > 0) {
				this.form.globalErrors = [];
			}
		};

		this.messageClick = function(e) {
			if (ctrl.user.message === ctrl.messageAlsoAddAnyQuestionsOrMessage) {
				ctrl.user.message = '';
			}
		};

		this.focusTextarea = (e) => {
			let textarea = $element[0].querySelector('.textarea');
			if (textarea) {
				textarea.focus();
				this.messageClick();
			}
		};

		this.cbPhoneHasError = (flag) => {
			if (ctrl.isMobile) {
				if (flag === true) {
					ctrl.phoneHasError = true;
				} else {
					ctrl.phoneHasError = false;
				}
			}
		};
	}]
});
